module.exports = __webpack_public_path__ + "img/dj.63e20123.svg";